import { render } from "./Object.vue?vue&type=template&id=686e32a4&lang=pug"
import script from "./Object.vue?vue&type=script&lang=js"
export * from "./Object.vue?vue&type=script&lang=js"

import "./Object.vue?vue&type=style&index=0&id=686e32a4&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__